<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head" id="Ack"><a id="page_6">A<span class="small">CKNOWLEDGMENTS</span></a></p><a id="page_6">
<p class="para1">The work of a book is never entirely the work of one person, and so it is with <i>Southern Arizona Cemeteries</i>. Now is the time to list the individuals and organizations that have generously given their assistance. The Arizona Historical Society Libraries and Archives, the Library of Congress, Stephen Gregory (Fort Huachuca Museum), Khaleel Saba and Leslie Matthaei at the Western Archeological and Conservation Center (WACC), Kristin Sanderson and Fort Bowie, Susan and Brian Ballard, John Horne from the Baseball Hall of Fame, Carolyn O’Bagy Davis, Jeanette Done, Mary Kasulaitis, Catherine Sutherland Hartline (niece of Frank O. Sutherland and great-granddaughter of William H. Sutherland), and Richard Lapidus all supplied images and information. Eileen Grade and Anne Vandenberg (with Evergreen Cemetery) and Kay Mullenax and Tammy Turner (with Holy Hope Cemetery) were especially helpful. Ilona Smerekanich and Andy Haratyk provided information on the Evergreen Cemetery in Bisbee. Lincoln Chin, from the Tucson Chinese Cultural Center, translated Chinese tombstones. My “cemeterying” friends include Alene Fletcher, Betty Barr, and Betty Leavengood. No book sees the light of day without the aid of a publisher and editor, and I am grateful to Alyssa Jones and the Arcadia Publishing staff. Finally, the biggest contributors are those pioneers who left their stones on a place called Southern Arizona.</p>
<p class="para">Unless otherwise noted, all images appear courtesy of the author.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?71f30a8b